import $ from "jquery";
import whatInput from "what-input"; // eslint-disable-line no-unused-vars

window.$ = $;

import Foundation from "foundation-sites"; // eslint-disable-line no-unused-vars
import Slick from "../vendor/slick-1.8.0/slick/slick"; // eslint-disable-line no-unused-vars
import objectFitImages from "../vendor/object-fit-images-3.2.3";
import "../vendor/cookie-disclaimer/cookie-disclaimer";
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/foundation-explicit-pieces';

$(document).foundation();

$(window).scroll(function showScrollUp() {
  if ($(this).scrollTop() > 100) { // eslint-disable-line no-magic-numbers
    $(".back-to-top").fadeIn();
  } else {
    $(".back-to-top").fadeOut();
  }
});

objectFitImages();

var $current = $('.current');
var $total = $('.total');
var $slickElement = $('.project-slider');

$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $current.text(i);
    $total.text(slick.slideCount);
});

$slickElement.slick({
  infinite      : true,
  speed         : 300,
  slidesToShow  : 1,
  adaptiveHeight: true,
  arrows        : true,
  fade          : true,
  prevArrow     : $('.prev'),
  nextArrow     : $('.next')
});



// WEBPACK FOOTER //
// ./src/assets/js/app.js